import React from 'react';
import { Empty } from 'antd';
import SpinnerChidori from 'components/SpinnerChidori/SpinnerChidori';
import { DetailedSparkJobDTO } from 'types/types';
import {
  formatCode,
  detectSyntaxLabel,
  getLangPillClassName,
  highlightSQL,
} from 'components/JobsTable/JobsDetailsSidebar/JobDetailsSidebarHelpers';
import '../JobCodeModal.scss';

type JobCodeContentProps = {
  job: DetailedSparkJobDTO | undefined;
  isLoading: boolean;
};

export const JobCodeContent: React.FC<JobCodeContentProps> = ({
  job,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="job-code__centered">
        <SpinnerChidori />
      </div>
    );
  }

  if (!job) {
    return (
      <Empty
        description="No job selected"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  if (!job.code) {
    return (
      <Empty
        description="Error fetching job code"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  const codePillClass = getLangPillClassName(job.mvLanguage);
  const codeString = formatCode(job.code);
  const syntaxLabel = detectSyntaxLabel(codeString);

  return (
    <div className="job-code__body">
      <div className="job-code__header">
        {job.mvLanguage && (
          <span className={`job-code__lang-pill ${codePillClass}`}>
            {job.mvLanguage}
          </span>
        )}
      </div>
      <div className="job-code__code-wrapper">
        <span className="job-code__syntax-label">{syntaxLabel}</span>
        <pre className="job-code__pre">
          {highlightSQL(codeString)}
        </pre>
      </div>
    </div>
  );
};

export default JobCodeContent;